import React from 'react';
import TableDetails from './TableDetails';

function Orders({ orders, onOrderClick, title }) {
  if (!orders) {
    return null;
  }

  const parsedOrders = orders.map(order => {
    return {...order, response_data: JSON.parse(order.response_data)};
  });

  return (
    <>
      <TableDetails orders={parsedOrders} onOrderClick={onOrderClick} title={title} />
    </>
  )
}

export default Orders